import { TagItemCount, TagItemType } from '../../graphql/generated/api-graphql'

export enum TagType {
  all = 'all',
  Article = 'articles',
  Cheese = 'fromages',
  Folder = 'dossiers',
  Recipe = 'recettes',
  Plate = 'plateaux',
}

export const TagTypeArray = [
  TagType.all,
  TagType.Recipe,
  TagType.Article,
  TagType.Cheese,
  TagType.Folder,
  TagType.Plate,
]

export function resolveTagType(type?: string | null | string[]): TagType {
  switch (type) {
    case TagItemType.CulinaryArticle:
    case TagItemType.Article:
      return TagType.Article
    case TagItemType.Cheese:
      return TagType.Cheese
    case TagItemType.Recipe:
      return TagType.Recipe
    case TagItemType.CulinaryFolder:
      return TagType.Folder
    case TagItemType.Plate:
      return TagType.Plate

    default:
      return TagType.all
  }
}

export function resolveTagItemType(type: TagType): TagItemType | undefined {
  switch (type) {
    case TagType.Article:
      return TagItemType.Article
    case TagType.Cheese:
      return TagItemType.Cheese
    case TagType.Recipe:
      return TagItemType.Recipe
    case TagType.Folder:
      return TagItemType.CulinaryFolder
    case TagType.Plate:
      return TagItemType.Plate
  }
}

export function getTagCardsCount(
  count?: TagItemCount[],
  type?: TagType
): number {
  switch (type) {
    case TagType.all:
      return count?.reduce((total, item) => total + item.count, 0) ?? 0
    case TagType.Folder:
      return (
        count?.find((item) => item.type === TagItemType.CulinaryFolder)
          ?.count ?? 0
      )
    case TagType.Article:
      return (
        (count?.find((item) => item.type === TagItemType.Article)?.count ?? 0) +
        (count?.find((item) => item.type === TagItemType.CulinaryArticle)
          ?.count ?? 0)
      )
    case TagType.Cheese:
      return count?.find((item) => item.type === TagItemType.Cheese)?.count ?? 0
    case TagType.Recipe:
      return count?.find((item) => item.type === TagItemType.Recipe)?.count ?? 0
    case TagType.Plate:
      return count?.find((item) => item.type === TagItemType.Plate)?.count ?? 0
  }
  return 0
}
